import { AfterViewInit, Component, EventEmitter, Output, ViewChild} from '@angular/core';
import {ImportComponentComponent} from "../../shared/import-component/import-component.component";
import {ApiPathsService} from "../../api-paths.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Azienda} from "../../Admin/models/Azienda";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {ApiRestService as ClientiApiRestService} from "../../Admin/_service/api-rest.service";

@Component({
  selector: 'app-listino-import',
  templateUrl: './listino-import.component.html'
})
export class ListinoImportComponent implements AfterViewInit{
  @Output() Uploaded = new EventEmitter<boolean>();
  @ViewChild('ImportComponent')
  private ImportComponent:  ImportComponentComponent;
  Fornitori: Azienda[] = [];
  FornitoriSelezionati: Azienda[] = [];
  data: string;
  clientiDropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField:'id',
    textField: 'nominativo'
  };
  constructor(
    private apiPaths: ApiPathsService,
    private modalService : NgbActiveModal,
    private clientiApiRest : ClientiApiRestService
  ) {}
  ngAfterViewInit() {
    this.clientiApiRest.getListaAziende({ruolo: "F", page:0, size: 10}).subscribe(data=> this.Fornitori = data?.data)
    this.ImportComponent.updateSelectedUrl(this.apiPaths.getBaseAPI() + '/prodotti/listino/import');
  }

  uploaded(){
    this.Uploaded.emit(true);
  }

  closeModal() {
    this.modalService.dismiss();
  }

  RespChange($event) {
    this.ImportComponent.parametri = {'id_fornitore': this.FornitoriSelezionati[0]?.id?.toString(), 'data' : this.data};
  }
}
